export default __webpack_public_path__ + "static/media/Palisades.9f36a66e.jpg";